"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.shadeColor = exports.COLORS = void 0;
var COLORS = exports.COLORS = Object.freeze({
  blue: '#3574d6',
  buttonHover: '#2661bd',
  darkGray: '#222222',
  error: '#d8372a',
  gray: '#424242',
  help: '#222222',
  label: '#526b63',
  lightGray: '#c8c8c8',
  lighterGray: '#e1e1e1',
  mediumBlue: '#3574d6',
  mediumGray: '#666666',
  metadata: '#526b63',
  primaryTypography: '#333333',
  white: '#ffffff'
});
var toHex = function toHex(n) {
  var hex = n.toString(16);
  return (hex.length === 1 ? "0".concat(hex) : hex).toUpperCase();
};
var shadeHexChannel = function shadeHexChannel(hex, percent) {
  var channel = parseInt(hex, 16);
  var adjusted = Math.round(channel * (100 + percent) / 100);
  var normalized = Math.min(255, Math.max(0, adjusted));
  return toHex(normalized);
};
var shadeColor = exports.shadeColor = function shadeColor(color, percent) {
  var red = shadeHexChannel(color.substring(1, 3), percent);
  var green = shadeHexChannel(color.substring(3, 5), percent);
  var blue = shadeHexChannel(color.substring(5, 7), percent);
  var alpha = color.substring(7);
  return "#".concat(red).concat(green).concat(blue).concat(alpha);
};